import styled from 'styled-components';
import GlobalStyle from './GlobalStyle';
import Header from './Header.js';
import impressum from '../images/imprint.png';
import studio from '../images/studio-scaled.jpg';

export default function Content(){
 
    return(
<div id="ContentWrapper"> 
<GlobalStyle />  
<Header id="top" /> 
<Section1>  
<p class="pagination">01</p> 
<h1 class="animated-text">infinite sequences</h1>
<p>Oliver Starckjohann</p><br />
</Section1>
<Section2 id="about">
<p class="pagination">02</p>   
<h1>About Me</h1>   
<h3><TopAnchor href="https://soundcloud.com/os-303" target="_new">Synthesis</TopAnchor></h3>
<p>Playground: step sequencer / samplers / arpeggiator / 303 / midi sync / ADSR / LFO</p>
<h3><TopAnchor href="https://themotosocial.com/hamburg-deutsch" target="_new">Moto - Culture</TopAnchor></h3>
<h3><TopAnchor href="https://www.surfinbiarritz.com/" target="_new">Surfing</TopAnchor></h3>
<h3><TopAnchor href="https://www.visitberlin.de/de/urban-art-berlin" target="_new">Urban Art Berlin</TopAnchor></h3>
<p>Creative Lab / Moto - Culture / Surfing / Art / Fashion / Design</p>
</Section2>
<Section3 id="imprint"> 
<p class="pagination">03</p>    
<h1>Impressum /<br /> Imprint</h1>
<img src={impressum} alt="Bild mit Text" />
<p> - - </p>
<p>Keine Haftung für weiterführende Links:</p>
<Textwrap>
<p>Die Website enthält Links zu Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
    Diese Links stellen keine Zustimmung zu den Inhalten dieser Websites seitens Oliver Starckjohann dar. 
    Für die Verfügbarkeit und den Inhalt der verlinkten Websites sind ausschließlich deren Betreiber:innen verantwortlich.
</p>
</Textwrap>
</Section3>
</div>
);
}

const Section1 = styled.section`
    display: block;
    height: auto;
    width: 98%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    padding-bottom: 60px;
    color: #ffffff;
    background-color: #1aa7d5;
    word-wrap: break-word;
    overflow-y: auto;
    overflow-x: hidden;
`
const Section2 = styled.section`
    display: block;
    height: auto;
    width: 98%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    padding-bottom: 60px;
    color: #ffffff;
    background-color: #AB218E;
    word-wrap: break-word;
    overflow-y: auto;
`
const Section3 = styled.section`
     display: block;
    height: auto;
    width: 98%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    padding-bottom: 60px;
    color: #ffffff;
    background-image: url(${studio});
    background-size: cover;
    background-repeat: no-repeat;
    word-wrap: break-word;
    overflow-y: auto;
    overflow-x: hidden;
`
const Section4 = styled.section`
    display: block;
    height: auto;
    width: 98%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    padding-bottom: 60px;
    color: #ffffff;
    background-color: #e71336;
    word-wrap: break-word;
    overflow-y: auto;
`
const Section5 = styled.section`
    display: block;
    height: auto;
    width: 98%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    padding-bottom: 60px;
    color: #D7FF80;
    background-color: #C905FF;
    word-wrap: break-word;
    overflow-y: auto;
    overflow-x: hidden;
`
const Section6 = styled.section`
    display: block;
    height: auto;
    width: 98%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    padding-bottom: 60px;
    color: #ffffff;
    background-image: url(${studio});
    background-size: cover;
    background-repeat: no-repeat;
    word-wrap: break-word;
    overflow-y: auto;
    overflow-x: hidden;
`
const Spacer = styled.div`
    display: block;
    height: 1rem;
    width: 1rem;
`
const Textwrap = styled.div`
    display: block;
    height: auto;
    width: 98%;
`

const TopAnchor = styled.a`
    color: #7dd7f5;
    text-decoration: none;
    `